import React from 'react';
import Subject from './Subject';
import Simulation from './Simulation';
import MaterialView from './MaterialView';
import axios from 'axios';

import * as Globals from './../Globals';


export default class CourseView extends React.Component {

    constructor(props) {
        super(props);

        this.userID = this.props.userID;
        this.id = this.props.id;
        this.course = {};
        this.testSimulations = [];
        this.viewResultID = -1;
        this.simulating = false;
        this.materialID = -1;

        this.state = {
            name: "",
            subjects: [],
            testSimulations: [],
        }
    }

    componentDidMount() {
        let cookie = this.props.LogoutOnCookieNotSet();
        let topicId = -1;
        axios.get(Globals.BASE_PATH + 'api/courses/' + this.props.id,
            {
                headers: {
                    'Accept': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + cookie
                }
            }).then(response => {
            this.setState({
                name: response.data['course-topic'].name,
                description: response.data.description,
            });
            topicId = response.data['course-topic'].id
        }).catch((error) => {
            this.props.CheckAuthError(error);
        }).finally(() => axios.get(Globals.BASE_PATH + `api/course-topics/${topicId}/subjects`,
            {
                headers: {
                    'Accept': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + cookie
                }
            })
            .then(response => {
                let subjects = [];
                response.data.data.forEach((subject) =>
                    subjects.push({
                        id: subject.id,
                        name: subject.name,
                        description: subject.description,
                        visible: subject.visible
                    })
                );
                this.setState({
                    subjects: subjects
                });
            })
            .catch((error) => {
                this.props.CheckAuthError(error);
            }));


        /*
        this.course = { id: 1, name: "Krankenpflegerkurs" };
        this.testSimulations = [
            {
                id: 1,
                subjects: [
                    { id: 1, name: "Erste Hilfe" },
                    { id: 2, name: "Blutabnahme" }
                ],
                date: "23. Januar 2018",
                maxPoints: 40,
                reachedPoints: 33
            },
            {
                id: 2,
                subjects: [
                    { id: 1, name: "Erste Hilfe" },
                    { id: 2, name: "Blutabnahme" }
                ],
                date: "27. Januar 2018",
                maxPoints: 40,
                reachedPoints: 37
            }
        ];
        var testSimulations = [];
        this.testSimulations.map( (testSimulation) => {
            var subjectNames = [];
            testSimulation.subjects.map( (subject) =>
                subjectNames.push(subject.name)
            );
            var percent = ((testSimulation.reachedPoints / testSimulation.maxPoints) * 100);
            testSimulations.push(
                {
                    subjects: subjectNames,
                    percent: percent,
                    date: testSimulation.date
                }
            )
            return null;
        });
        this.setState({
            testSimulations: testSimulations
        });
        */
    }

    getSubjectIDs() {
        let ids = [];
        this.state.subjects.forEach(subject => ids.push(subject.id));
        return ids;
    }

    refresh() {
        this.componentDidMount();
    }

    changeViewProtocolID(index) {
        this.viewResultID = this.testSimulations[index].id;
        this.forceUpdate();
    }

    closeViewProtocol() {
        this.viewResultID = -1;
        this.forceUpdate();
    }

    handleCloseCreator() {
        this.startSimulation = false;
        this.forceUpdate();
    }

    handleCloseMaterialView() {
        this.materialID = -1;
        this.forceUpdate();
    }

    changeMaterialID(id) {
        this.materialID = id;
        this.forceUpdate();
    }

    startSimulation() {
        this.simulating = true;
        this.forceUpdate();
    }

    finishSimulation() {
        this.simulating = false;
        this.forceUpdate();
    }

    getRenderBlock() {
        if (this.simulating) {
            return (
                <Simulation CheckAuthError={this.props.CheckAuthError}
                            LogoutOnCookieNotSet={this.props.LogoutOnCookieNotSet} userID={this.userID} courseID={this.id}
                            finishSimulation={this.finishSimulation.bind(this)} subjectIDs={this.getSubjectIDs()}/>
            );
        }
        if (this.materialID >= 0) {
            return (
                <div>
                    <MaterialView CheckAuthError={this.props.CheckAuthError}
                                  LogoutOnCookieNotSet={this.props.LogoutOnCookieNotSet} id={this.materialID}
                                  handleCloseMaterialView={this.handleCloseMaterialView.bind(this)}/>
                    <button  style={{"marginTop": "20px"}} className="btn  center-block btn-back" type="button"
                            onClick={() => this.handleCloseMaterialView()}>Zurück zum Kurs
                    </button>
                </div>
            );
        } else {
            return (
                <div className="container-courseOverview">
                    <h2 className="text-center">{this.state.name}</h2>
                    <button style={{"marginBottom": "20px"}} className="btn btn-danger center-block" type="button"
                            onClick={() => this.props.closeCourseView()}>Zur Kursübersicht
                    </button>
                    <div className="panel panel-default userSubjects">
                        <div className="panel-heading text-center"><h3>Fächer</h3></div>
                        <ul className="list-group">
                            {
                                this.state.subjects.map((subject) => {
                                    return !subject.visible ? null : (
                                        <li key={subject.id} className="list-group-item" onClick={() => this.changeMaterialID(subject.id)}>
                                            <Subject name={subject.name} description={subject.description}/>

                                        </li>
                                    );
                                })
                            }
                        </ul>
                    </div>
                    <div className="container-course" >
                        <h2  className="text-center">Prüfungssimulation</h2>
                        <p className="text-center"><i>Sie können eine Prüfungssimulation dieses Kurses durchführen.
                            Beachten Sie, dass Fragen aus allen Fächern, die zu diesem Kurs gehören, ausgewählt werden.
                            Ihr Ergebnis ist für niemanden sichtbar.</i></p>
                        <button className="btn btn-info center-block" onClick={() => this.startSimulation()}>Simulation
                            starten
                        </button>
                    </div>
                </div>
            );
        }
    }

    render() {
        return (this.getRenderBlock());
    }

}



// WEBPACK FOOTER //
// ./src/user/CourseView.js